var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"intro_top"},[_c('span',[_vm._v("联系方式")]),_c('em',[_vm._v("TEAM INTRODUCTION")])])])
}]

export { render, staticRenderFns }